<template>
  <header class="header" :class="{'home-header': state.isHome}">
    <h1 v-if="state.isHome" class="logo">
      <router-link to="/">
        中国社区发展网
        <small>China Community Development Association</small>
      </router-link>
    </h1>
    <template v-else>
      <div class="header-menu-back" @click="() => router.back()" />
      <h2>{{name}}</h2>
    </template>
    <div class="header-menu-btn" @click="() => toogleMenuShow(true)" />
  </header>
  <section class="header-menu-layout" :class="{show: state.showMenu}">
    <nav class="header-menu">
      <mHeaderSearch :close="() => toogleMenuShow(false)" />
      <ul>
        <li><router-link to="/user">会员中心</router-link></li>
        <li><router-link to="/">网站首页</router-link></li>
        <li><router-link to="/single/1">协会概况</router-link></li>
        <li v-for="(item, index) in state.nav" :key="item.value">
          <template v-if="item.children">
            <div class="header-menu-item">
              <router-link :to="`/channel/${item.value}`" @click="() => toogleMenuShow(false)">{{item.label}}</router-link>
              <div class="header-menu-item-arrow" :class="{active: state.navStatus[index]}" @click="() => changeNavStatus(index)" />
            </div>
            <ul :class="`${state.navStatus[index] ? 'show' : ''} child-height-${item.children.length}`">
              <li v-for="child in item.children" :key="child.value">
                <router-link :to="`/channel/${child.value}`" @click="() => toogleMenuShow(false)">{{child.label}}</router-link>
              </li>
            </ul>
          </template>
          <router-link v-else :to="`/channel/${item.value}`" @click="() => toogleMenuShow(false)">{{item.label}}</router-link>
        </li>
      </ul>
    </nav>
    <div class="header-menu-mask" @click="() => toogleMenuShow(false)" />
  </section>
  <section class="header-space" />
</template>

<script>
import { reactive, watch } from 'vue'
import { getTreeChannel } from '@/api/channel'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'mHeader',
  props: {
    name: {
      type: String, default: ''
    }
  },
  setup (props) {
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      nav: [],
      navStatus: [],
      showMenu: false,
      isHome: true
    })
    const getData = async () => {
      const data = await getTreeChannel()
      state.nav = data
      state.isHome = route.path === '/'
    }
    getData()
    watch(() => route.path, () => {
      state.isHome = route.path === '/'
    })
    const changeNavStatus = (index) => {
      // state.navStatus = []
      state.navStatus[index] = !state.navStatus[index]
    }

    const toogleMenuShow = (status) => {
      state.showMenu = status
    }
    return {
      state,
      changeNavStatus,
      toogleMenuShow,
      router
    }
  }
}
</script>
